import React, { useEffect, useState } from "react";
import { Stepper } from "@mui/material";
import arrow from "../../assets/Icons/PNG/orange-arrow.png";
import check from "../../assets/Icons/PNG/check-mark.png";
import "./FormStepper.css";
import * as Constants from "../../Constants"

export default function FormStepper({ activeStep, setActiveStep, steps, handleBack, successSteps, handleTabsSwitch, isMedicalCanvassDoNot }) {
  const [tabsSteps, setTabsSteps] = useState(successSteps)

  const goToStep = async (targetStep) => {
    if (targetStep <= activeStep) {
      const updatedSteps = handleBack()
      setTabsSteps(updatedSteps)
      setActiveStep(targetStep)
    } else {
      const updatedSteps = handleTabsSwitch()
      setTabsSteps(updatedSteps)
      for (let i = activeStep; i < targetStep; i++) {
        if (!updatedSteps.includes(i)) {
          setActiveStep(i);
          break;
        }
        setActiveStep(targetStep);
      }
    }
  }

  return (
    <Stepper activeStep={activeStep}>
      <div className="stepper">
        {steps.map((step, index) => (
          <button
            type="button"
            onClick={() => goToStep(index)}
            disabled={steps[index] !== Constants.RECORDS_REQUEST_STEP && isMedicalCanvassDoNot}
            key={index}
            className={`step ${index === activeStep ? "active" : ""}`}
          >
            {step}
            {index < steps.length - 1 && (
              <span className="arrow">
                {
                  <img src={(tabsSteps.includes(index) || successSteps.includes(index)) ? check : arrow} alt="arrow"></img>
                }
              </span>
            )}
          </button>
        ))}
      </div>
    </Stepper>
  );
}
